// EXTERNAL
import React, { useRef } from "react";
import { useParams } from "react-router-dom";
// COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
// CONTEXT
import { useUserState } from "../../../../contexts/user.context";
import { useCreativeState, useCreativeDispatch } from "../../../../contexts/creative.context";
import { useNotificationDispatch } from "../../../../contexts/notification.context";
import { useMediaLoadingDispatch } from "../../../../contexts/mediaLoading.context";
// HELPERS
import add_font from "../../../../helpers/add_font";
// FUNCTIONS
import { getFontMimeType } from "../functions/getFontMimeType";

export function FontUpload() {
  const user = useUserState();
  const creative = useCreativeState();
  const { creativeId } = useParams<Record<string, string | undefined>>();
  const notificationDispatch = useNotificationDispatch();
  const mediaLoadingDispatch = useMediaLoadingDispatch();
  const creativeDispatch = useCreativeDispatch();

  const uploadFileInputRef = useRef<HTMLInputElement>(null);
  const replaceFileInputRef = useRef<HTMLInputElement>(null);

  const handleUploadButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.blur();
    uploadFileInputRef.current?.click();
  };

  const handleReplaceButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.blur();
    replaceFileInputRef.current?.click();
  };

  return (
    <>
      <div className="flex flex-row items-end justify-between">
        <label className="flex items-center ma0 margin-top-2 text-size-2 fw5 tl self-end color-text-3 platform-font" htmlFor="font-upload">
          CTA button font
          <span className="ml1">
            <ComponentLibrary.PCTooltip message={"Upload font file (otf, ttf) for custom CTA button font"} type={"dark"} icon={"info-circle"} id={"font-tooltip"} color={""} />
          </span>
        </label>
      </div>
      <div className="flex margin-top-3 margin-bottom-1">
        <div style={{ pointerEvents: creative.metadata.button.font?.fileName ? "none" : "auto" }}>
          <input
            id="font-upload"
            name="font-upload"
            type="file"
            accept="font/collection, font/otf, font/sfnt, font/ttf, font/woff, font/woff2"
            hidden
            ref={uploadFileInputRef}
            onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
              const file = e.target.files?.[0]!;
              await add_font({
                file,
                name: file.name,
                formatType: creative.metadata.format,
                user,
                teamId: user.teamId,
                creativeId: creativeId!,
                mimeType: await getFontMimeType(file),
                creativeDispatch,
                notificationDispatch,
                mediaLoadingDispatch,
              });
            }}
          />
          <ComponentLibrary.PCActionButton text={creative.metadata.button.font?.fileName.substring(0, 12) || "Upload Font"} color={"background-color-primary-3"} textColor={"white"} iconRight={creative.metadata.button.font?.fileName ? "circle-check" : "upload"} clickHandler={(e) => handleUploadButtonClick(e as React.MouseEvent<HTMLButtonElement>)} />
        </div>
        {creative.metadata.button.font?.fileName && (
          <>
            <ComponentLibrary.PCSpacer type={"margin"} position={"left"} size={3} />
            <ComponentLibrary.PCDivider vertical={true} />
            <ComponentLibrary.PCSpacer type={"margin"} position={"left"} size={3} />
            <div className="upload-button-wrapper dim relative overflow-hidden dib-ns">
              <input
                id="replace-font-upload"
                name="replace-font-upload"
                type="file"
                accept="font/collection, font/otf, font/sfnt, font/ttf, font/woff, font/woff2"
                hidden
                ref={replaceFileInputRef}
                onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
                  const file = e.target.files?.[0]!;
                  await add_font({
                    file,
                    name: file.name,
                    formatType: creative.metadata.format,
                    user,
                    teamId: user.teamId,
                    creativeId: creativeId!,
                    mimeType: await getFontMimeType(file),
                    creativeDispatch,
                    notificationDispatch,
                    mediaLoadingDispatch,
                  });
                }}
              />
              <ComponentLibrary.PCActionButton text={"Replace"} textColor={"color-text-5"} color={"platform-background-platform-background-4"} clickHandler={(e) => handleReplaceButtonClick(e as React.MouseEvent<HTMLButtonElement>)} />
            </div>
            <ComponentLibrary.PCSpacer type={"margin"} position={"left"} size={3} />
            <ComponentLibrary.PCActionButton
              text={<ComponentLibrary.PCIconPicker icon={"trash"} />}
              textColor={"color-text-5"}
              color={"platform-background-platform-background-4"}
              clickHandler={async (e: any) => {
                e.currentTarget.blur();
                uploadFileInputRef.current!.value = "";
                creativeDispatch({
                  type: "UPDATE_CREATIVE_METADATA_FONT_FILENAME",
                  payload: { fileName: "" },
                });
              }}
            />
          </>
        )}
      </div>
    </>
  );
}
